import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeActiveAddonProps extends ModalEditComponentProps { }

const ModalChangeActiveAddon: React.FC<ModalChangeActiveAddonProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateAddon {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeleteAddon {...{ setOpened, onSubmit, allRowData }} />
    }
}


interface ModalReactivateAddonProps extends ModalEditComponentProps { }

const ModalReactivateAddon: React.FC<ModalReactivateAddonProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/updateProduct',
        data: {
            id: allRowData?.id,
            active: true
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveThisAddon', '¿Seguro que quieres reactivar este complemento?'),
            subtitle: t('onceReactivatedAbleInAddonList', 'Una vez reactivado volverá a aparecer en el listado de complementos'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}


interface ModalDeleteAddonProps extends ModalEditComponentProps { }

const ModalDeleteAddon: React.FC<ModalDeleteAddonProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/deleteProduct',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureUnableAddon', '¿Seguro que quieres desactivar este complemento?'),
            subtitle: t('onceUnabledCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
            buttonAccept: t('unable', 'Desactivar')
        }} />
    )
}

export default ModalChangeActiveAddon